import $http from '../../shared/http';

export const marital_statuses = {
  namespaced: true,
  state: () => {
    return {
      maritalStatusesForSelect: null,
    };
  },
  getters: {
    getmaritalStatusesForSelect: (state) => (currentLanguage) => {
      const maritalStatuses = state?.maritalStatusesForSelect ?? [];
      if (!currentLanguage || !maritalStatuses.length) {
        return [];
      }

      return (
        maritalStatuses?.map?.((maritalStatus) => {
          return {
            value: maritalStatus.value,
            text: maritalStatus.localisations?.[currentLanguage]?.name || maritalStatus.text,
          };
        }) ?? []
      );
    },
  },
  mutations: {
    setmaritalStatusesForSelect: (state, payload) => (state.maritalStatusesForSelect = payload),
  },
  actions: {
    async LOAD_MARITAL_STATUSES_FOR_SELECT({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get('/marital_statuses')
          .then((response) => {
            commit('setmaritalStatusesForSelect', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
